import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TiposEmpresa {
  private tipos_empresa = [
    "Correduría",
    "Corredor persona física",
    "Agente exclusivo",
    "Agente vinculado",
    "Colaborador"
  ];


  get tipos_empresa_list(): string[] {
    return this.tipos_empresa;
  }

  get default_value(): string {
    return this.tipos_empresa[0];
  }

  // --------------------------------------------------------
  existeTipoEmpresa(tipo_empresa: string): boolean {
    return this.tipos_empresa.includes(tipo_empresa);
  }

}
